import { Price } from 'src/types';
import { FilterOffer, FilterSelection, IFilterConfig } from './types';

const filterOffer = (
  offer: FilterOffer,
  config: IFilterConfig,
  selection?: FilterSelection
): boolean => {
  // Keep offers with missing info if we have a function defined for it
  return config.missingInfoFn
    ? config.filterFn(offer, selection) ||
        config.missingInfoFn(offer, selection)
    : config.filterFn(offer, selection);
};

function updateMainOffer(
  offer: Price,
  config: IFilterConfig,
  selection?: FilterSelection
): Price {
  if (config.filterFn(offer, selection)) {
    // Main offer is valid
    return offer;
  }

  // Swap in first valid alternative offer as new main offer
  const firstFilteredAlternativeOffer = offer?.alternativePrices?.find(x =>
    config.filterFn(x, selection)
  );
  if (!offer?.alternativePrices || !firstFilteredAlternativeOffer) {
    return offer;
  }
  const newAlternatives = offer.alternativePrices;
  const pos = newAlternatives.indexOf(firstFilteredAlternativeOffer);
  newAlternatives.splice(pos);
  newAlternatives.unshift(firstFilteredAlternativeOffer);
  return {
    ...firstFilteredAlternativeOffer,
    type: offer.type,
    authorizedDealer: offer.authorizedDealer,
    history: offer.history,
    weight: offer.weight,
    store: offer.store,
    uncertainData: offer.uncertainData,
    offerPrices: offer.offerPrices,
    deliveryOptions: offer.deliveryOptions,
    authorizedBy: offer.authorizedBy,
    alternativePrices: newAlternatives,
  } as Price;
}

export const filterOffersGeneric = (
  offers: Price[],
  config: IFilterConfig,
  selection?: FilterSelection
): Price[] => {
  if (!offers.length || (selection && selection.length === 0)) {
    return offers;
  }
  if (!config.filterAlternativeOffers) {
    return offers.filter(x => filterOffer(x, config, selection));
  }

  // Filtering alternative offers
  const filteredOffers: Price[] = [];
  offers.forEach(offer => {
    const filteredAlternatives = offer.alternativePrices?.filter(x =>
      filterOffer(x, config, selection)
    );
    if (!filteredAlternatives?.length) {
      return;
    }
    const offerWithFilteredAlternatives = {
      ...offer,
      alternativePrices: filteredAlternatives,
    };
    filteredOffers.push(
      updateMainOffer(offerWithFilteredAlternatives, config, selection)
    );
  });
  return filteredOffers;
};
